import React, { useEffect, useState } from 'react';
import 'bootstrap-select';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ProjectKeyService from 'service/ClientTransmoraService/ProjectKeyService';
import { hasProjectKeyAccess } from 'helpers/hasPrivilege';
import CustomDropdown from 'component/CustomDropdown';
import { PageSizeOption } from 'domain/constant/PageSizeOption';

const ProjectKey: React.FC = () => {

  const { profile } = useSelector((state: any) => state.auth);
  const [data, setData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState<{ id: string; projectName: string } | null>(null);
  const [deleting, setDeleting] = useState(false);

  const projectKeyService = ProjectKeyService()

  const canCreate = hasProjectKeyAccess(profile, 'manage');
  const canUpdate = hasProjectKeyAccess(profile, 'manage');
  const canDelete = hasProjectKeyAccess(profile, 'manage');

  const fetchData = async () => {
    const token = profile?.data.token;
    if (!token) return;

    setLoading(true);
    try {
      const res = await projectKeyService.ProjectKeyList(token, searchTerm, currentPage, pageSize);
      console.log(res)
      setData(res.data ?? []);
      setTotalPages(res.pagination?.totalPage ?? 0);
      setTotalRecords(res.pagination?.totalRecords ?? 0)
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (item: any) => {
    setSelectedDeleteItem({ id: item.id, projectName: item.projectName });
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;
    const token = profile?.data.token;
    if (!token) return;

    setDeleting(true);
    try {
      await projectKeyService.ProjectKeyDelete(token, selectedDeleteItem.id);
      alert(`"${selectedDeleteItem.projectName}" berhasil dihapus.`);
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
      fetchData();
    } catch (err: any) {
      alert(err.message || 'Gagal menghapus data.');
    } finally {
      setDeleting(false);
    }
  };

  const handleCloseDeleteModal = () => {
    if (deleting) return;
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);

  const handleSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setCurrentPage(1);
    fetchData();
  };

  return (

    <div className="page-wrapper">
      <div className="row">
        <div className="col-12">
          <div className="d-flex">
            <h5 style={{ flex: 1 }}>Project Key</h5>
            <div>
              <p>TransMore Project Key</p>
            </div>
          </div>
        </div>
        <div className="col-12">

          <div className="p-4" style={{ background: 'white' }}>
            <div className="d-flex mb-3 flex-nowrap gap-2 overflow-auto text-nowrap">

              <form className="d-flex" onSubmit={handleSearchClick}>
                <input
                  type="text"
                  className="form-control form-control-compact me-2"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: 120 }}
                />
                <button type="submit" className="btn btn-primary px-4">
                  <i className="fa-solid fa-search"></i>
                </button>
              </form>

              <div className="d-flex justify-content-end" style={{ flex: 1 }}>
                {canCreate && (
                  <>
                    <Link to="/client-project-key/0" className='float-end text-decoration-none tm-text-primary'>
                      <button className="btn btn-primary">
                        <span className="me-2">
                          Add
                        </span>
                        <i className="fa-solid fa-plus"></i>
                      </button>
                    </Link>
                  </>
                )}
              </div>
            </div>

            <table className="table table-condensed table-hover">
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Project Name</th>
                  <th>Number of Keys</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  !loading ?
                    data.length > 0 ? (
                      data.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.projectName}</td>
                          <td>{item.numberOfKey}</td>
                          <td>
                            <div className="d-flex">
                              {canUpdate && (
                                <>
                                  <Link to={'/client-project-key/' + item.id}>
                                    <button className="btn btn-outline-warning btn-small-compact border-0">
                                      <i className="fa-solid fa-edit"></i>
                                    </button>
                                  </Link>
                                </>
                              )}
                              {canDelete && (
                                <>
                                  <button
                                    className="btn btn-outline-danger btn-small-compact border-0 ms-2"
                                    onClick={() => handleDeleteClick(item)}
                                    title="Hapus"
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )
                    :
                    <tr>
                      <td colSpan={9} className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <div className="d-flex align-items-center">
                <div className="me-4 d-flex align-items-center">
                  <label className="me-2">Rows per page:</label>
                  <CustomDropdown
                    value={pageSize}
                    options={PageSizeOption.options}
                    onChange={(opt) => {
                      setPageSize(Number(opt.id));
                      setCurrentPage(1);
                    }}
                    align="top"
                  />
                </div>
                <span className="me-3">
                  {`${(currentPage - 1) * pageSize + 1}–${Math.min(currentPage * pageSize, totalRecords)} of ${totalRecords}`}
                </span>

                <nav>
                  <ul className="pagination mb-0">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>

                    <li className="page-item disabled">
                      <span className="page-link" style={{ border: 0 }}>{currentPage}</span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(totalPages)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && selectedDeleteItem && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }}
          onClick={handleCloseDeleteModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content p-4">
              <div className="mb-3">
                <h5 className="fw-bold mb-1">Hapus Project Key</h5>
                <hr />
                <p className="mb-0">
                  Apakah Anda yakin ingin menghapus config untuk project{' '}
                  <strong>"{selectedDeleteItem.projectName}"</strong>?
                </p>
                <p className="text-danger small mt-1 mb-0">
                  Tindakan ini tidak dapat dibatalkan.
                </p>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={handleCloseDeleteModal}
                  disabled={deleting}
                  style={{ borderRadius: '8px' }}
                >
                  Batal
                </button>
                <button
                  className="btn btn-danger px-4"
                  onClick={handleConfirmDelete}
                  disabled={deleting}
                  style={{ borderRadius: '8px' }}
                >
                  {deleting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Menghapus...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-trash me-2"></i>
                      Hapus
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

};

export default ProjectKey;